/**
 * @generated SignedSource<<35f5a7de96f11d207f495ba8c0b1d85c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AskFellowHooksContextFromURLQuery$variables = {
  guid: string;
  hasEvent: boolean;
  id: string;
  skipNode: boolean;
};
export type AskFellowHooksContextFromURLQuery$data = {
  readonly event?: {
    readonly stream: {
      readonly displayName: string;
      readonly id: string;
      readonly otherUser: {
        readonly fullName: string;
      } | null;
    } | null;
  } | null;
  readonly node?: {
    readonly __typename: "Channel";
    readonly id: string;
    readonly name: string;
  } | {
    readonly __typename: "NoteStream";
    readonly displayName: string;
    readonly id: string;
    readonly otherUser: {
      readonly fullName: string;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AskFellowHooksContextFromURLQuery = {
  response: AskFellowHooksContextFromURLQuery$data;
  variables: AskFellowHooksContextFromURLQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "guid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasEvent"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipNode"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v9 = [
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "otherUser",
    "plural": false,
    "selections": [
      (v8/*: any*/)
    ],
    "storageKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = [
  {
    "kind": "Variable",
    "name": "guid",
    "variableName": "guid"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "otherUser",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AskFellowHooksContextFromURLQuery",
    "selections": [
      {
        "condition": "skipNode",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v9/*: any*/),
                "type": "NoteStream",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  (v10/*: any*/)
                ],
                "type": "Channel",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "hasEvent",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "event",
            "args": (v11/*: any*/),
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "eventByGuid",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "AskFellowHooksContextFromURLQuery",
    "selections": [
      {
        "condition": "skipNode",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/),
                  (v12/*: any*/)
                ],
                "type": "NoteStream",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/)
                ],
                "type": "Channel",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "hasEvent",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "event",
            "args": (v11/*: any*/),
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "eventByGuid",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "100d16c42e43218b6b56e401df0835ae",
    "id": null,
    "metadata": {},
    "name": "AskFellowHooksContextFromURLQuery",
    "operationKind": "query",
    "text": "query AskFellowHooksContextFromURLQuery(\n  $id: ID!\n  $guid: String!\n  $hasEvent: Boolean!\n  $skipNode: Boolean!\n) {\n  node(id: $id) @skip(if: $skipNode) {\n    __typename\n    ... on NoteStream {\n      id\n      displayName\n      otherUser {\n        fullName\n        id\n      }\n    }\n    ... on Channel {\n      id\n      name\n    }\n    id\n  }\n  event: eventByGuid(guid: $guid) @include(if: $hasEvent) {\n    stream {\n      id\n      displayName\n      otherUser {\n        fullName\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec1345d7555b8c38ec2abb28d1364532";

export default node;
